import dayjs, { type Dayjs } from "dayjs";

import { cn } from "@fitness-app/utils/src/styles/cn";

import { CalendarDayCell } from "./CalendarDayCell";
import { getVisibleDays, toDayKey, WEEKDAY_LABELS, type CalendarEventsProps } from "./calendarModel";

interface WeekViewProps<T> extends CalendarEventsProps<T> {
  date: Dayjs;
}

// Siatka godzinowa nic tu nie daje: w kalendarzu klientki prawie wszystko jest całodniowe, a tam,
// gdzie liczy się godzina (wiadomości, konsultacje, wydarzenia wyzwań), jest ona w treści chipa.
// Tydzień = 7 kolumn bez limitu.
export const WeekView = <T,>({ date, eventsByDay, isDayDimmed, ...cellProps }: WeekViewProps<T>) => {
  const days = getVisibleDays("week", date);
  const today = dayjs();

  return (
    <div className="grid grid-cols-7 overflow-hidden rounded-xl border border-solid border-gray-200 bg-white">
      {days.map((day, index) => {
        const isToday = day.isSame(today, "day");

        return (
          <CalendarDayCell
            key={toDayKey(day)}
            {...cellProps}
            day={day}
            events={eventsByDay.get(toDayKey(day)) ?? []}
            className={cn(
              "min-h-[420px] border-0 border-solid border-gray-200",
              index !== 6 && "border-r",
              isDayDimmed?.(day) && "bg-gray-50/60",
            )}
            header={
              <div className="flex items-baseline gap-1.5">
                <span className="text-xs font-medium uppercase tracking-wide text-gray-500">
                  {WEEKDAY_LABELS[index]}
                </span>
                <span
                  className={cn(
                    "flex h-6 min-w-6 items-center justify-center rounded-full px-1 text-sm font-semibold tabular-nums",
                    isToday ? "bg-blue-600 text-white" : "text-gray-900",
                  )}
                >
                  {day.date()}
                </span>
              </div>
            }
          />
        );
      })}
    </div>
  );
};
